<template>
    <div class="fsa-hsa">
        <button 
            type="button"
            class="fsa-hsa-button"
            @click="openModal"
        >
            <img 
                alt="FSA/HSA Eligible Badge"
                src="@/assets/fsa-hsa/svg/fsa_hsa_eligible.svg"
            >
        </button>
        <Modal v-if="showModal" @close="closeModal">
            <div slot="body" class="fsa-hsa__modal-box">
                <button
                    type="button"
                    aria-label="Close"
                    class="fsa-hsa__modal-close"
                    @click="closeModal"
                >
                    <img 
                        alt="Close icon"
                        src="@/assets/fsa-hsa/svg/icon-close.svg"
                    >
                </button>
                <div class="fsa-hsa__modal-image">
                    <img 
                        alt="FSA/HSA banner"
                        src="@/assets/fsa-hsa/main.png"
                    >
                </div>
                <div class="fsa-hsa__modal-body">
                    <div class="fsa-hsa-modal-header">
                        <div>
                            <img 
                                alt="FSA/HSA logo"
                                src="@/assets/fsa-hsa/svg/flex-contrology.svg"
                            >
                        </div>
                        <div>
                            <h4>Checkout with your HSA/FSA card!</h4>
                            <p>*Online orders only.</p>
                        </div>
                    </div>
                    <div class="fsa-hsa-modal-steps">
                        <div class="step">
                            <img 
                                alt="FSA/HSA icon"
                                src="@/assets/fsa-hsa/svg/shop.svg"
                            >
                            <p>Shop for your favorite items</p>
                        </div>
                        <div class="line" />
                        <div class="step">
                            <img 
                                alt="FSA/HSA icon"
                                src="@/assets/fsa-hsa/svg/select.svg"
                            >
                            <p>Select Flex at checkout</p>
                        </div>
                        <div class="line" />
                        <div class="step">
                            <img 
                                alt="FSA/HSA icon"
                                src="@/assets/fsa-hsa/svg/confirm.svg"
                            >
                            <p>Confirm your eligibility</p>
                        </div>
                        <div class="line" />
                        <div class="step">
                            <img 
                                alt="FSA/HSA icon"
                                src="@/assets/fsa-hsa/svg/card.svg"
                            >
                            <p>Use your HSA/FSA card</p>
                        </div>
                    </div>
                    <div class="fsa-hsa-modal-footer">
                        <p>Contrology has partnered with Flex to enable you to pay with your pre-tax money. Follow the steps above to complete your purchase.</p>
                        <img 
                            alt="FSA/HSA icon"
                            src="@/assets/fsa-hsa/svg/powered_by_flex.svg"
                        >
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
    name: "fsa-hsa",

    components: {
        Modal
    },

    data() {
        return {
            showModal: false,
        };
    },

    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        }
    }
};
</script>

<style lang="scss">
    .fsa-hsa .modal-mask {
        z-index: 999999999999999;
    }

    .fsa-hsa .modal-container {
        display: flex;
        max-height: 90vh;
		overflow-y: auto;
		border-radius: 20px;
        width: 800px;
		max-width: 90vw;
        min-width: auto;
        padding: 0;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
    }

    .fsa-hsa .modal-body {
        display: contents;
    }

    .fsa-hsa-button {
        display: flex;
        padding: 0;
        margin: 10px 0;
        border: none;
        background: none;
        cursor: pointer;
    }

    .fsa-hsa__modal-box {
        position: relative;
        display: flex;
        height: 100%;
        width: 100%;
        max-width: 90vw;
        min-height: 419px;
        background-color: #FFF;
    }

    .fsa-hsa__modal-close {
        position: absolute;
        top: 15px;
        right: 15px;
        background: none;
        border: none;
        cursor: pointer;
    }

    .fsa-hsa__modal-image {
        display: flex;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .fsa-hsa__modal-body {
        display: grid;
        grid-template-rows: auto auto 1fr;
        flex: 1;
        padding: 43px;
    }

    .fsa-hsa-modal-header {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 33px 0;

        div:first-child {
            display: flex;
            align-items: center;
            gap: 0 9px;
        }

        h4 {
            font-size: 21px;
            text-align: center;
            line-height: 1.3;
            font-weight: 700;
            margin: 0;
        }

        p {
            margin: 6px 0 0;
        }
    }

    .fsa-hsa-modal-steps {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 0 4px;
        width: 100%;
        max-width: 390px;
        margin: 30px auto 60px;

        .step {
            position: relative;

            > img {
                width: 60px;
                height: 75px;
            }

            p {
                position: absolute;
                width: 83px;
                font-weight: 500;
                font-size: 12px;
                line-height: 1.2;
                text-align: center;
                left: -12px;
            }
        }

        .step:nth-child(3) {
            p {
                left: -20px;
            }
        }

        .line {
            width: 100%;
            height: 2px;
            border-bottom: 1.5px dashed #1D02FF;
        }

        .line:nth-child(2) {
            margin-left: -10px;
        }
    }

    .fsa-hsa-modal-footer {
        font-size: 12px;
        line-height: 1.2;
        text-align: center;
        display: grid;
        align-content: space-between;
        justify-items: center;
        gap: 20px 0;
        max-width: 500px;
        margin: 0 auto;
        letter-spacing: 0;
    }

    @media screen and (max-width: 768px) {
        .fsa-hsa__modal-image {
            display: none;
        }
        .fsa-hsa__modal-body {
            padding: 50px 15px 35px;
        }
        .fsa-hsa-modal-header {
            gap: 18px 9px;

            h4 {
                font-size: 18px;
            }
        }
        .fsa-hsa-modal-steps {
            margin: 10px auto;
            flex-direction: column;
            align-items: start;

            .step {
                display: flex;
                align-items: center;
                gap: 0 15px;
                padding: 15px;

                > img {
                    width: auto;
                    height: auto;
                }

                p {
                    position: static;
                    text-align: left;
                    width: auto;
                    font-size: 16px;
                }
            }

            .line {
                border-color: #C4C4C4;
            }

            .line:nth-child(2) {
                margin-left: 0;
            }
        }
    }

</style>
